<template>
  <b-form lg="3" ref="testMethodForm" @submit="onSubmit" @reset="onReset" class="needs-validation">
    <b-form-row>
      <b-col lg="4">
        <b-form-group id="testMethodName">
          <span class="fieldHeader">{{$t('name')}}:</span>
          <b-form-input id="nameInput"
                        type="text"
                        v-model="currentTestMethod.name"
                        required
                        :state="stateName">
          </b-form-input>
          <template slot="invalid-feedback">
            {{feedbackName}}
          </template>
        </b-form-group>

        <b-form-group id="questionFormatGroup">
          <span class="fieldHeader">{{$t('privatePage.questionFormat_header')}}:</span>

          <b-form-select id="questionFormatForm"
                        v-model="currentTestMethod.questionFormatId"
                        :options="questionFormats"
                        value-field="id"
                        text-field="name"
                        v-if="!hasNormValues"
                        novalidate
                        required>
          </b-form-select>
          <span v-else>
            {{currentTestMethod.questionFormat}}
          </span>
        </b-form-group>

        <b-form-group id="pdfTypeForm">
          <span class="fieldHeader">{{$t('privatePage.pdfType_header')}}:</span>

          <b-form-select id="pdfTypeForm"
                        v-model="currentTestMethod.pdfType"
                        :options="pdfTypes"
                        value-field="key"
                        text-field="value"
                        novalidate
                        >
          </b-form-select>
        </b-form-group>
        <b-form-group id="IsUsedWithoutStaticTextsGroup">
          <b-form-checkbox id="IsUsedWithoutStaticTextsCheckbox"
                           v-model="currentTestMethod.isUsedWithoutStaticTexts">
          {{ $t('privatePage.testmethod_isUsedWithoutStaticTexts') }}
          </b-form-checkbox>
        </b-form-group>

        <b-form-group id="timePerTestForm" style="margin-top:20px; padding-left: 0px;">
          <span class="fieldHeader">{{$t('privatePage.test_time')}}:</span>
          {{currentTestMethod.totalEstimatedQuestionTime}} {{$t('privatePage.minutes')}}
        </b-form-group>

        <b-form-group id="instruction">
          <span class="fieldHeader">{{$t('privatePage.instruction')}}:</span>
          <b-form-select id="instructionSelect"
                        required
                        novalidate
                        v-model="currentTestMethod.instructionId"
                        :options="filteredInstructions"
                        value-field="id"
                        text-field="name"
          />
        </b-form-group>

        <b-form-group id="isTimeLimitedGroup"
                      v-if="currentTestMethod.id">
          <b-form-checkbox id="isTimeLimitedCheckbox"
                          v-model="currentTestMethod.isTimeLimited">
          {{ $t('privatePage.isLimited') }}
          </b-form-checkbox>
        </b-form-group>

        <b-form-group id="isUsedForTestBuilderGroup">
          <b-form-checkbox id="isUsedForTestBuilderCheckbox"
                           v-model="currentTestMethod.isForTestBuilder"
                           v-show="selectedQuestionFormat === 1">
          {{ $t('privatePage.isUsedForTestBuilder_label') }}
          </b-form-checkbox>
        </b-form-group>
        <b-form-group id="isExcelExportEnabledGroup">
          <b-form-checkbox id="isExcelExportEnabledCheckbox"
                          v-model="currentTestMethod.isExcelExportEnabled">
          {{ $t('privatePage.excelExportEnabled_label') }}
          </b-form-checkbox>
        </b-form-group>

        <!-- <b-form-group id="isLsiCoachingAvailableGroup">
          <b-form-checkbox id="isLsiCoachingAvailableCheckbox"
                          v-model="currentTestMethod.isLsiCoachingAvailable">
          {{ $t('privatePage.lsiCoachingAvailable_label') }}
          </b-form-checkbox>
        </b-form-group> -->

        <b-form-group id="isActiveGroup"
                      v-if="currentTestMethod.id">
          <b-form-checkbox id="isActiveCheckbox"
                          v-model="currentTestMethod.isActive">
          {{ $t('privatePage.isActive') }}
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col lg="6">

        <b-form-group>
          <b-button type="submit" class="me-1" @click="beforeSaving(false)">{{ $t('save') }}</b-button>
          <b-button type="reset" class="me-1" variant="danger">{{ $t('cancel') }}</b-button>
          <b-button type="button" variant="danger" v-if="currentTestMethod.id" @click.stop="onDeleteTestMethod">{{ $t('delete') }}</b-button>
        </b-form-group>

        <b-form-group>
          <b-alert v-model="alerts.countdown"
                  dismissible
                  :variant="alerts.variant"
                  @closed="alerts.countdown=0"
                  @close-count-down="countDownChanged">
            {{alerts.message}}
          </b-alert>
        </b-form-group>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'test-method-detail-editor',
  computed: {
    ...mapGetters(['selectedCulture', 'defaultCulture']),
    ...mapGetters('testMethodsModule', ['questionFormats', 'pdfTypes']),
    ...mapGetters(['userId']),
    stateName() {
      if (this.currentTestMethod && this.currentTestMethod.name) {
        return this.currentTestMethod.name.length > 0
      }
      return false
    },
    feedbackName() {
      return this.$t('name_required_feedback')
    },
    submitMessage() {
      return this.$t('save_ok_feedback')
    },
    selectedQuestionFormat() {
      return this.currentTestMethod.questionFormatId
    },
    hasNormValues() {
      return false
    }
  },
  methods: {
    ...mapActions('testMethodsModule', {
      updateTestMethod: 'updateTestMethod',
      addTestMethod: 'addTestMethod',
      deleteTestMethod: 'deleteTestMethod',
      getNormScales: 'getNormScales'
    }),
    onSubmit: function(evt) {
      if (this.validateForm()) {
        evt.preventDefault()
        this.currentTestMethod.doRandomize = this.doRandomize
        this.currentTestMethod.selectedLanguageId = this.selectedCulture.languageId

        if (this.selectedQuestionFormat !== 1) {
          this.currentTestMethod.isForTestBuilder = false
        }

        if (this.currentTestMethod.id) {
          this.updateTestMethod(this.currentTestMethod)
            .then(() => {
              this.showSuccessMessage(this.submitMessage)
              this.getNormScales({
                testMethodId: this.currentTestMethod.id,
                languageId: this.selectedCulture.languageId,
                defaultLanguageId: this.defaultCulture.languageId
              }).then(() => {
              })
            })
            .catch(error => {
              this.showErrorMessage(error)
            })
        } else {
          let testMethod = this.currentTestMethod
          testMethod.userId = this.userId
          this.addTestMethod(testMethod)
            .then((response) => {
              this.getNormScales({
                testMethodId: response.id,
                languageId: this.selectedCulture.languageId,
                defaultLanguageId: this.defaultCulture.languageId
              }).then(() => {
              })
              this.showSuccessMessage(this.submitMessage)
            })
            .catch(error => {
              this.showErrorMessage(error)
            })
            .catch(error => {
              this.showErrorMessage(error)
            })
        }
      }
    },
    beforeSaving(doRandomize) {
      this.doRandomize = doRandomize
    },
    onReset() {
      this.currentTestMethod = {}
      this.$router.go(-1)
    },
    onDeleteTestMethod() {
      if (
        window.confirm(
          this.$t('privatePage.testmethodDelete_confirmation')
        )
      ) {
        this.deleteTestMethod(this.currentTestMethod)
          .then(() => {
            window.alert(this.$t('privatePage.testmethodDelete_message'))
            this.currentTestMethod = {}
            this.$router.go(-1)
          })
          .catch(error => {
            this.showErrorMessage(error)
          })
      }
    },
    validateForm: function() {
      return true
    },
    countDownChanged: function(dismissCountDown) {
      this.alerts.countdown = dismissCountDown
    },
    showMessage: function(message) {
      this.alerts.message = message
      this.alerts.countdown = this.alerts.dismissSecs
      this.alerts.variant = 'info'
    },
    showErrorMessage: function(message) {
      this.alerts.message = message
      this.alerts.countdown = this.alerts.dismissSecs
      this.alerts.variant = 'danger'
    },
    showSuccessMessage: function(message) {
      this.alerts.message = message
      this.alerts.countdown = this.alerts.dismissSecs
      this.alerts.variant = 'success'
    }
  },
  data() {
    return {
      alerts: {
        dismissSecs: 3,
        countdown: 0,
        message: '',
        variant: 'warning'
      },
      filteredInstructions: []
    }
  },
  watch: {
    selectedQuestionFormat() {
      this.filteredInstructions = this.instructions.filter(
        instruction =>
          instruction.questionFormatId ===
          this.currentTestMethod.questionFormatId
      )
    }
  },
  props: {
    scales: {},
    currentTestMethod: {},
    instructions: {}
  },
  created() {
    if (this.currentTestMethod && this.currentTestMethod.id) {
      this.filteredInstructions = this.instructions.filter(
        instruction =>
          instruction.questionFormatId ===
          this.currentTestMethod.questionFormatId
      )
    }
  }
}
</script>
